import { ReactComponent as seti } from 'assets/images/sidemenu/setting.svg';

const icons = {
  seti: seti
};


const storedUserDetails = localStorage.getItem('rolepermission');

const logUserType = localStorage.getItem('usertype');

let userpermission = null;
let loginpermission = [];

if (storedUserDetails) {
  try {
    userpermission = JSON.parse(storedUserDetails);
    loginpermission = userpermission.permissions || [];
  } catch (error) {
    console.error('Failed to parse storedUserDetails:', error);
  }
}

const settings = {
  id: 'settings',
  title: 'Settings',
  type: 'group',
  children: [
    {
      id: 'Setting',
      title: 'Settings',
      type: 'collapse',
      icon: icons.seti,
      children: [
        {
          id: 'Applogo',
          title: 'App Logo',
          type: 'item',
          url: '/GPMofpXek/settings/applogo'
        },
        {
          id: 'General',
          title: 'General',
          type: 'item',
          url: '/GPMofpXek/settings/general'
        },
        {
          id: 'Email',
          title: 'Email',
          type: 'item',
          url: '/GPMofpXek/settings/email'
        },
        {
          id: 'Payment',
          title: 'Payment',
          type: 'item',
          url: '/GPMofpXek/settings/payment'
        },
        {
          id: 'SMS',
          title: 'SMS',
          type: 'item',
          url: '/GPMofpXek/settings/sms'
        },
        {
          id: 'GoogleMapApi',
          title: 'API',
          type: 'item',
          url: '/GPMofpXek/settings/googlemapapi'
        },
        {
          id: 'LCDWPaymentSettings',
          title: 'LCDW Payment Settings',
          type: 'item',
          url: '/GPMofpXek/settings/lcdwpaymentsettings'
        },
        {
          id: 'EmailPreferences',
          title: 'Email Preferences',
          type: 'item',
          url: '/GPMofpXek/settings/emailpreferences'
        },
        {
          id: 'FileFormatSize',
          title: 'File Format & Size',
          type: 'item',
          url: '/GPMofpXek/settings/fileformatsize'
        },
        {
          id: 'EmailTemplate',
          title: 'Email Template',
          type: 'collapse',
          breadcrumbs: true,
          children: [
            {
              id: 'Header',
              title: 'Header',
              type: 'item',
              url: '/GPMofpXek/settings/template/header',
            },
            // {
            //   id: 'CreateEmailTemplate',
            //   title: 'Create Email Template',
            //   type: 'item',
            //   url: '/GPMofpXek/email-template/create-email',
            // },
            {
              id: 'ListEmailTemplate',
              title: 'List Email Template',
              type: 'item',
              url: '/GPMofpXek/settings/template/list-email',
            },
            {
              id: 'Footer',
              title: 'Footer',
              type: 'item',
              url: '/GPMofpXek/settings/template/footer',
            },
            // {
            //   id: 'Activity',
            //   title: 'Activity',
            //   type: 'item',
            //   url: '/GPMofpXek/setting/email-template/activity',
            // }
          ]
        },
        {
          id: 'Currency',
          title: 'Currency',
          type: 'item',
          url: '/GPMofpXek/settings/currency'
        },
        {
          id: 'LocationLimits',
          title: 'Location Limits',
          type: 'item',
          url: '/GPMofpXek/settings/location-limits'
        },
        {  
           
          id: 'country-list',
          title: 'Country List',
          type: 'item',
          url: '/GPMofpXek/settings/country/list',          
          
        },
        {             
           
        id: 'industry-list',
        title: 'Industry List',
        type: 'item',
        url: '/GPMofpXek/settings/industry/list',          
          
        },
        {
          id: 'back-up',
          title: 'Back Up',
          type: 'item',
          url: '/GPMofpXek/settings/back-up'
        }
      ]
    },
  ]
}


const modulesToCheck = ['App_logo', 'General', 'Email', 'Payment', 'Sms', 'Api', 'LCDW_payment', 'Email_preferences', 'File_format_size', 'Header', 'List_email_template', 'Footer', 'Currency', 'Location_limits', 'Country_list', 'Industry_list'];

if (logUserType !== 'super_admin') {

  if (settings && Array.isArray(settings.children) && loginpermission && Array.isArray(loginpermission)) {

    modulesToCheck.forEach(moduleId => {
      const module = settings.children.find(child => child.id === moduleId);

      if (module) {
        const modulePermission = loginpermission.find(permission => permission.module === moduleId);
        if (modulePermission) {
          if (modulePermission.create === 0 &&
              modulePermission.read === 0 &&
              modulePermission.update === 0 &&
              modulePermission.deletePermission === 0) {
              settings.children = settings.children.filter(child => child.id !== moduleId);
          }
        }
      }
    });
  }
  else
  {
    console.error('support.children or loginpermission is undefined or not an array');

  }
}

  if (settings.children.length === 0) {
    settings.title = '';
  }

export default settings;
